import { XLATE } from "../data.js";

// Traducteur de commandes IOS-XE ↔ Junos ↔ NX-OS.
export function buildXlateView(ctx) {
  const { s, patch } = ctx;
  const q = s.xlateQuery.trim().toLowerCase();
  const xrows = XLATE.filter((r) => !q || (r.intent + " " + r.family + " " + r.ios + " " + r.junos + " " + r.nxos).toLowerCase().includes(q));
  const cp = (txt) => () => {
    if (!navigator.clipboard) { console.error("[netdoc] clipboard API unavailable"); return; }
    navigator.clipboard.writeText(txt).catch((e) => console.error("[netdoc] clipboard copy failed:", e.message));
  };
  return {
    xlateQuery: s.xlateQuery,
    onXlateQuery: (e) => patch({ xlateQuery: e.target.value }),
    xlateRows: xrows.map((r) => ({ ...r, copyA: cp(r.ios), copyB: cp(r.junos), copyC: cp(r.nxos) })),
    xlateCount: xrows.length + " intention" + (xrows.length > 1 ? "s" : "") + (q ? " sur " + XLATE.length : ""),
    xlateFoot: "Cliquez une commande pour la copier. Les équivalences sont fonctionnelles, pas littérales : Junos sépare configuration et validation.",
  };
}
